import EastIcon from '@mui/icons-material/East'
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { Dispatch, FC, SetStateAction, useEffect, useMemo } from 'react'
import { OrganizationTableItem } from 'types/organizations_table'
import { createTaskTemplates } from './TASK_TEMPLATES'

type TasklistTemplateType = { key: string; name: string; id: number }

interface OnboardingTemplateSelectorProps {
  deal: OrganizationTableItem
  pickerOpen: boolean
  setPickerOpen: Dispatch<SetStateAction<boolean>>
  selectedTemplateId: string
  setSelectedTemplateId: Dispatch<SetStateAction<string>>
  selectedTemplate: { id: string; label: string; items: TasklistTemplateType[] }
  selectedKeys: string[]
  setSelectedKeys: Dispatch<SetStateAction<string[]>>
  onConfirmTask: () => void
}

const OnboardingTemplateSelector: FC<OnboardingTemplateSelectorProps> = ({
  deal,
  pickerOpen,
  setPickerOpen,
  selectedTemplateId,
  setSelectedTemplateId,
  selectedTemplate,
  selectedKeys: _selectedKeys,
  setSelectedKeys,
  onConfirmTask,
}) => {
  const TASK_TEMPLATES = createTaskTemplates({ ...deal, containsSEO: true }) ?? []
  // Compute all keys for the current template
  const allTemplateKeys = useMemo(() => (selectedTemplate?.items ?? []).map(i => i.key), [selectedTemplate?.items])

  // Force-select everything whenever the template changes
  useEffect(() => {
    setSelectedKeys(allTemplateKeys)
  }, [allTemplateKeys, setSelectedKeys])

  return (
    <Dialog open={pickerOpen} onClose={() => setPickerOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Select a task list to start onboarding</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 700 }}>
              Task List Template
            </Typography>
            <Select
              size="small"
              fullWidth
              value={selectedTemplateId}
              onChange={e => setSelectedTemplateId(String(e.target.value))}
              sx={{ mt: 0.5 }}
            >
              {TASK_TEMPLATES.map(t => (
                <MenuItem key={t.id} value={t.id}>
                  {t.label}
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Divider />

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: 1 }}>
            <Typography>Onboarding Status:</Typography>
            {deal?.onboardingStatus && deal?.onboardingStatus !== 'Onboarding' ? (
              <>
                <Typography sx={{ color: renderColorByString(deal?.onboardingStatus ?? 'Awaiting Kickoff') }}>
                  {deal?.onboardingStatus ?? 'Awaiting Kickoff'}
                </Typography>
                <EastIcon sx={{ fontSize: 16 }} />
                <Typography sx={{ color: renderColorByString('Awaiting Kickoff') }}>Awaiting Kickoff</Typography>
              </>
            ) : (
              <Typography sx={{ color: renderColorByString('Awaiting Kickoff') }}>Awaiting Kickoff</Typography>
            )}
          </Box>

          <Divider />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography>Tasks to be created</Typography>
            <Chip size="small" label={(selectedTemplate?.items ?? []).length} />
          </Box>

          <List
            disablePadding
            dense
            sx={{ maxHeight: 350, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
          >
            {(selectedTemplate?.items ?? []).map(item => {
              return (
                <ListItem
                  key={item.key}
                  disablePadding
                  sx={{ height: '100%', maxHeight: 30, px: 2 }}
                  // No onClick — non-interactive preview
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Checkbox
                      edge="start"
                      tabIndex={-1}
                      disableRipple
                      checked={true}
                      disabled
                      sx={{
                        color: 'text.disabled',
                        '& .MuiSvgIcon-root': {
                          color: 'text.disabled',
                        },
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItem>
              )
            })}
          </List>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPickerOpen(false)}>Cancel</Button>
        <Button variant="contained" onClick={onConfirmTask}>
          Create Tasks
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default OnboardingTemplateSelector

// import {
//   Box,
//   Button,
//   Checkbox,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   ListItemButton,
//   MenuItem,
//   Select,
//   Stack,
//   Typography,
// } from '@mui/material'
// import { renderColorByString } from 'components/DataGrid/renderColorByString'
// import { Dispatch, FC, SetStateAction } from 'react'
// import { OrganizationTableItem } from 'types/organizations_table'
// import { TASK_TEMPLATES } from './TASK_TEMPLATES'
// import EastIcon from '@mui/icons-material/East'

// type TasklistTemplateType = {
//   key: string
//   name: string
//   id: number
// }

// interface OnboardingTemplateSelectorProps {
//   deal: OrganizationTableItem
//   pickerOpen: boolean
//   setPickerOpen: Dispatch<SetStateAction<boolean>>
//   selectedTemplateId: string
//   setSelectedTemplateId: Dispatch<SetStateAction<string>>
//   selectedTemplate: { id: string; label: string; items: TasklistTemplateType[] }
//   selectedKeys: string[]
//   setSelectedKeys: Dispatch<SetStateAction<string[]>>
//   onConfirmTask: () => void
// }

// const OnboardingTemplateSelector: FC<OnboardingTemplateSelectorProps> = ({
//   deal,
//   pickerOpen,
//   setPickerOpen,
//   selectedTemplateId,
//   setSelectedTemplateId,
//   selectedTemplate,
//   selectedKeys,
//   setSelectedKeys,
//   onConfirmTask,
// }) => {
//   return (
//     <Dialog open={pickerOpen} onClose={() => setPickerOpen(false)} maxWidth="sm" fullWidth>
//       <DialogTitle>Select a task list to start onboarding</DialogTitle>
//       <DialogContent>
//         <Stack spacing={2}>
//           <Box>
//             <Typography variant="caption" sx={{ fontWeight: 700 }}>
//               Task List Template
//             </Typography>
//             <Select
//               size="small"
//               fullWidth
//               value={selectedTemplateId}
//               onChange={e => setSelectedTemplateId(String(e.target.value))}
//               sx={{ mt: 0.5 }}
//             >
//               {TASK_TEMPLATES.map(t => (
//                 <MenuItem key={t.id} value={t.id}>
//                   {t.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </Box>

//           <Divider />
//           <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
//             <Typography>Onboarding Status:</Typography>
//             <Typography sx={{ color: renderColorByString(deal?.onboardingStatus ?? 'Staging') }}>{`${
//               deal?.onboardingStatus ?? 'Staging'
//             }`}</Typography>
//             <EastIcon sx={{ fontSize: 16 }} />
//             <Typography sx={{ color: renderColorByString('Onboarding') }}>{'Onboarding'}</Typography>
//           </Box>
//           <Divider />
//           <Typography variant="subtitle2">Tasks to be created</Typography>
//           <List
//             disablePadding
//             dense
//             sx={{ maxHeight: 350, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
//           >
//             {(selectedTemplate?.items || []).map(item => {
//               const checked = selectedKeys.includes(item.key)
//               return (
//                 <ListItem
//                   key={item.key}
//                   secondaryAction={null}
//                   disablePadding
//                   sx={{ height: '100%', maxHeight: 30, px: 2 }}
//                   onClick={() =>
//                     setSelectedKeys(prev => (checked ? prev.filter(k => k !== item.key) : [...prev, item.key]))
//                   }
//                   disabled
//                 >
//                   <ListItemIcon>
//                     <Checkbox edge="start" tabIndex={-1} disableRipple checked={checked} />
//                   </ListItemIcon>
//                   <ListItemText primary={item.name} />
//                 </ListItem>
//               )
//             })}
//           </List>
//         </Stack>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={() => setPickerOpen(false)}>Cancel</Button>
//         <Button variant="contained" onClick={onConfirmTask}>
//           Create Tasks
//         </Button>
//       </DialogActions>
//     </Dialog>
//   )
// }
// export default OnboardingTemplateSelector
